import { render, staticRenderFns } from "./v-filemanager.vue?vue&type=template&id=1fbdfd43"
import script from "./v-filemanager.vue?vue&type=script&lang=js"
export * from "./v-filemanager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports